import { RuleSet } from 'styled-components';

import { TPublication } from '@vNext/models/Publications';
import { abTheme } from './ab';
import { apTheme } from './ap';
import { btTheme } from './bt';
import { e24Theme } from './e24';
import { omniTheme } from './omni';
import { saTheme } from './sa';
import { vgTheme } from './vg';
import { svdTheme } from './svd';
import { vknoTheme } from './vkno';
import { wellobeTheme } from './wellobe';

type TBrandedTheme = {
    [key: string]: RuleSet<object>;
}

export const brandedTheme: TBrandedTheme = {
    ab: abTheme,
    ap: apTheme,
    bt: btTheme,
    e24: e24Theme,
    omni: omniTheme,
    sa: saTheme,
    svd: svdTheme,
    vg: vgTheme,
    vkno: vknoTheme,
    wellobe: wellobeTheme,
} satisfies Partial<Record<TPublication, RuleSet<object>>>;

export const getBrandTheme = (publicationID?: TPublication): RuleSet<object> | null => {
    if (!publicationID) return null;
    if (!(publicationID in brandedTheme)) return null;

    return brandedTheme[publicationID];
};
